export default __webpack_public_path__ + "static/media/vps-remote-desktop.3ed091a4.png";